export default (props, {
  rhythm
}) => ({
  category: {
    marginBottom: rhythm(1)
  }
})



// WEBPACK FOOTER //
// ./components/slices/FAQs/styles.js